import {
  POLICY_LIST_REQUEST,
  POLICY_LIST_SUCCESS,
  POLICY_LIST_FAIL,
  POLICY_LIST_RESET,
  POLICY_STATS_REQUEST,
  POLICY_STATS_SUCCESS,
  POLICY_STATS_FAIL,
  POLICY_STATS_RESET,
  POLICY_SEARCH_REQUEST,
  POLICY_SEARCH_SUCCESS,
  POLICY_SEARCH_FAIL,
  POLICY_SEARCH_RESET,
  POLICY_SINGLE_REQUEST,
  POLICY_SINGLE_SUCCESS,
  POLICY_SINGLE_FAIL,
  POLICY_SINGLE_RESET,
  POLICY_PER_CATEGORY_REQUEST,
  POLICY_PER_CATEGORY_SUCCESS,
  POLICY_PER_CATEGORY_FAIL,
  POLICY_PER_CATEGORY_RESET,
} from "constants/policyConstants";

export const listPoliciesReducer = (state = { policiesList: [] }, action) => {
  switch (action.type) {
    case POLICY_LIST_REQUEST:
      return { loading: true };
    case POLICY_LIST_SUCCESS:
      return { loading: false, policiesList: action.payload, success: true };
    case POLICY_LIST_FAIL:
      return { loading: false, error: action.payload };
    case POLICY_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const statsPoliciesReducer = (state = { policiesStats: [] }, action) => {
  switch (action.type) {
    case POLICY_STATS_REQUEST:
      return { loading: true };
    case POLICY_STATS_SUCCESS:
      return { loading: false, policiesStats: action.payload, success: true };
    case POLICY_STATS_FAIL:
      return { loading: false, error: action.payload };
    case POLICY_STATS_RESET:
      return { policiesStats: [] };
    default:
      return state;
  }
};

export const searchPoliciesReducer = (state = { policiesSearch: [] }, action) => {
  switch (action.type) {
    case POLICY_SEARCH_REQUEST:
      return { loading: true };
    case POLICY_SEARCH_SUCCESS:
      return { loading: false, policiesSearch: action.payload, success: true };
    case POLICY_SEARCH_FAIL:
      return { loading: false, error: action.payload };
    case POLICY_SEARCH_RESET:
      return [];
    default:
      return state;
  }
};

export const singlePolicyReducer = (state = { policySingle: {} }, action) => {
  switch (action.type) {
    case POLICY_SINGLE_REQUEST:
      return { loading: true };
    case POLICY_SINGLE_SUCCESS:
      return { loading: false, policySingle: action.payload, success: true };
    case POLICY_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case POLICY_SINGLE_RESET:
      return { policySingle: {} };
    default:
      return state;
  }
};

export const listPoliciesPerCategoryReducer = (state = { policiesListPerCategory: [] }, action) => {
  switch (action.type) {
    case POLICY_PER_CATEGORY_REQUEST:
      return { loading: true };
    case POLICY_PER_CATEGORY_SUCCESS:
      return {
        loading: false,
        policiesListPerCategory: action.payload,
        success: true,
      };
    case POLICY_PER_CATEGORY_FAIL:
      return { loading: false, error: action.payload };
    case POLICY_PER_CATEGORY_RESET:
      return [];
    default:
      return state;
  }
};
